import React , { useState }  from "react";
import { PlusIcon, MinusIcon } from "@heroicons/react/solid";
import {
  useCompanyQueryShareHolder
} from 'data/company';
import {number_format} from 'components/config/Common';
import ToolTipCompany from 'components/ui/ToolTipCompany';
import InvestorChart from './investor-chart'
export default function Investorsection({companyinfo}) {
    const [openSections, setOpenSections] = useState({});
    const [view, setView] = useState("Yearly");
    const [maxYear , setMaxYear] = useState(2022);
    const toggleSection = (period) => {
    setOpenSections((prev) => ({
      ...prev,
      [period]: !prev[period],
    }));
  };

  const {
    companyshareholder,
    total_shareholder,
    years_list,
    start_year,
    isLoading: loading,
    error,
  } = useCompanyQueryShareHolder(companyinfo?.id);

  //console.log('yearly===',companyshareholder)


 const getQuarter = (month) => {
  if (["Mar"].includes(month)) return "Q4";
  if (["Jun"].includes(month)) return "Q1";
  if (["Sep"].includes(month)) return "Q2";
  if (["Dec"].includes(month)) return "Q3";
};

  const convertFormatYear = (formate_year) => {
    const quarterly = {};
    const yearly = {};
    const hasMarch = new Set();

     Object.keys(formate_year).forEach(period => {
    const [year, month] = period.split(" ");

    // Quarterly
    //quarterly[`${year} ${month}`] = [period];
    quarterly[`${year} ${month}`] = [period];
    // Track March existence
    if (month === "Mar") {
      hasMarch.add(year);
    }
  });

    Object.keys(formate_year).forEach(period => {
      const [year, month] = period.split(" ");
     // const quarter = getQuarter(month);

    quarterly[`${year} ${month}`] = [period];
      // Financial Year (ends in Mar)
    // Financial Year (ends in Mar)
    /*const fyYear = month === "Mar" ? year : Number(year) + 1;*/
    const fyYear = month === "Mar" ? year : year;
    if (!hasMarch.has(fyYear)) return;
    const fyKey = `${fyYear} Mar`;

  if (!yearly[fyKey]) yearly[fyKey] = [];
    yearly[fyKey].push(period);
  });
    return {
      Quarterly: quarterly,
      Yearly: yearly,
    };
  };

  const { Quarterly, Yearly } = convertFormatYear(years_list);
  /*const displayKeys = view === "Quarterly"
  ? Object.keys(Quarterly).filter(period => {
      const [year] = period.split(" ");
      return Number(year) >= maxYear;
    })
  : Object.keys(Yearly);
  */
 const displayKeys = (() => {
  if (view === "Quarterly") {
    return Object.keys(Quarterly).filter(period => {
      const [year] = period.split(" ");
      return Number(year) >= maxYear;
    });
  }

  // Yearly view
  const yearlyKeys = Object.keys(Yearly);

  // Get latest quarter from Quarterly
  const quarterlyKeys = Object.keys(Quarterly);

  if (quarterlyKeys.length === 0) return yearlyKeys;

  // Sort to find latest quarter
  const sortedQuarterly = [...quarterlyKeys].sort((a, b) => {
    const [yearA, monthA] = a.split(" ");
    const [yearB, monthB] = b.split(" ");
    return new Date(`${monthA} 1, ${yearA}`) - new Date(`${monthB} 1, ${yearB}`);
  });

  const latestQuarter = sortedQuarterly[sortedQuarterly.length - 1];

  // If latest quarter already exists in yearly (March), don't duplicate
  if (!yearlyKeys.includes(latestQuarter)) {
    return [...yearlyKeys, latestQuarter];
  }

  return yearlyKeys;
})();


  const getyear = (period) =>{
      const [year, month] = period.split(" ");
      return year;
  }

    console.log("Yearly",companyshareholder);
  
  return (
      <>
      <section className="bg-white shadow-md z-50 rounded-xl py-5">
        <div className="flex justify-between px-5">
          <div >
            <h2 className="text-2xl font-semibold">Shareholding Pattern</h2>
            <div className="text-heading">Numbers in percentages</div>
          </div>
          <div className="flex">
          <button type="button" onClick={() => setView("Quarterly")} className={`px-4 h-10 text-sm text-heading border-y-[1px] border-x-[1px] 
          ${view == 'Quarterly' ? ' bg-accent-200 ':''}`} >
            Quarterly
            </button>
            <button type="button" onClick={() => setView("Yearly")} className={`px-4 h-10  text-sm text-heading border-y-[1px] border-r-[1px]
            ${view == 'Yearly' ? ' bg-accent-200 ':''} `} >
            Yearly
            </button>
          </div>
          </div>
        <div className="py-4"></div>
        {loading?
        <div className="relative overflow-x-auto bg-neutral-primary-soft shadow-xs rounded-base">
    <table className="w-full text-sm text-left text-body">
      <thead>
        <tr>
          <th className="px-6 py-3">
            <div className="h-4 w-32 bg-gray-200 animate-pulse rounded"></div>
          </th>
          {[...Array(4)].map((_, i) => (
            <th key={i} className="px-6 py-3">
              <div className="h-4 w-16 bg-gray-200 animate-pulse rounded"></div>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {[...Array(5)].map((_, i) => (
          <tr key={i} className="border-b">
            <td className="px-6 py-3">
              <div className="h-4 w-40 bg-gray-200 animate-pulse rounded"></div>
            </td>
            {[...Array(4)].map((_, j) => (
              <td key={j} className="px-6 py-3">
                <div className="h-4 w-12 bg-gray-200 animate-pulse rounded"></div>
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
        :
        <div class="relative overflow-x-auto bg-neutral-primary-soft shadow-xs rounded-base">
            <table class="w-full text-sm text-left border-0 rtl:text-right text-body">
                <thead class="bg-neutral-secondary-soft border-b border-default">
                    <tr >
                        <th scope="col" class="px-6 py-2 font-medium">
                        </th>
                         {Object.entries(displayKeys).map(([keyyear, valyear],index) => (
                            <th scope="col" class="px-6 py-2 font-medium text-heading">
                            {view === 'Yearly'
                            ? (
                                index === displayKeys.length - 1 && !valyear.includes("Mar")
                                  ? valyear              // Show full: 2023 Jun
                                  : getyear(valyear)     // Show only year: 2022
                              )
                            : valyear
                            }
                            </th>
                          ))}
                    </tr>
                </thead>
                <tbody>
                   {Object.keys(companyshareholder || {}).length === 0 ? (
                  <div className="p-5 text-heading"> Data is not ready yet , please check again
                </div>
                    ) : (<>
                    {Object.entries(companyshareholder).map(([period, shareholders]) => (
                   <React.Fragment key={period}>  
                   <tr 
                   className="odd:bg-gray-100 even:bg-neutral-secondary-soft border-b border-default cursor-pointer"
                      onClick={() => toggleSection(period)}
                      >
                        <th scope="row" className="px-6 py-2 font-medium text-heading whitespace-nowrap">
                           <div className="flex gap-1"> {period}
                            {openSections[period] ? (
                              <MinusIcon className="w-4 h-4 text-body" />
                            ) : (
                              <PlusIcon className="w-4 h-4 text-body" />
                            )}
                          </div>
                        </th>
                         {Object.entries(shareholders).map(([key, shareholdersper]) => (
                          <>
                          {Object.entries(shareholdersper).map(([key2, shareval]) => (
                            <>
                            {Object.entries(displayKeys).map(([keyyear, valyear]) => (
                            shareval?.type === 'category' && key2 == valyear  ? (<td className={`px-6 py-2 text-heading ${openSections[period] ? 'font-semibold' : 'font-normal'}`}>{shareval?.percent_holding}%</td>)
                            :
                             null
                            ))
                             }
                            </>
                          ))
                          }
                          </> 
                          ))}
                    </tr>
                    {openSections[period] && Object.entries(shareholders).map(([key, shareholdersper]) => (
                    <>
                    {key? <tr class="odd:bg-neutral-primary even:bg-neutral-secondary-soft border-b border-default">
                        <th className="px-6 py-2 font-medium ">
                            <div className="line-clamp-2 w-64 overflow-hidden text-sm leading-snug">
                            {key}
                            </div>
                          </th>
                       {Object.entries(shareholdersper).map(([key2, shareval]) => (
                        <>
                        {Object.entries(displayKeys).map(([keyyear, valyear]) => (

                        shareval?.type === 'individual'  && key2 == valyear ? (<td className="px-6 py-2 text-black">{shareval?.percent_holding} 
                        {shareval?.share_pledge_percentage && <div className="bg-red-400 px-2 py-1 rounded text-white ">Pledge {shareval?.share_pledge_percentage}%</div>}</td>)
                        :null
                        ))
                        }
                        </>
                       ))}
                      </tr> 
                      :null
                      }
                    </>
                      ))}
                    </React.Fragment>
                    ))}
                     </>
                        )}
                    <tr >
                        <td scope="col" class="px-6 py-2 font-medium">No. of Shareholders
                        </td>
                         {Object.entries(total_shareholder).map(([keysht, valsht]) => (
                          <>
                           {Object.entries(displayKeys).map(([keyyear, valyear]) => (
                            keysht == valyear && <td scope="col" class="px-6 py-2 font-medium">{number_format(valsht)}
                            </td>
                            ))
                            }
                          </>
                          ))}
                    </tr>
                </tbody>
               
            </table>
        </div>
        }

        <div className="flex p-4 gap-x-2 items-center">
            <div className="text-heading"> * The classifications might have changed from Sep'2022 onwards.
            </div>
            <div> 
                <ToolTipCompany 
          content ={`The New XLBR format added more details from Sep'22 onward<br /> <br />
            Classification such as bank and forigen portfolio investores were not avilable eariler.The sudden change in FII and DII can be because of this changes.<br /><br />
            Click on the line-items to see to see the name of individual entity. <br /><br/> We using data from nse. `}
          /> 
          </div>
          
          </div>
          {companyshareholder && <InvestorChart shareholders={companyshareholder} view={view} displayKeys={displayKeys} />}
      </section>
      
      </>
  );
}
